// Import Braze SDK
import * as braze from "@braze/web-sdk";

// Expose braze globally
window.braze = braze;
